import { chainJSON } from 'utils/Lang';
import { createClient } from 'contentful';

const client = createClient({
  space: '4n4tsnljd89p',
  accessToken: '35b7655ad24c40b9b5b2791bb0325f0089429ee75414875861fdaba7a9643ae3'
});

export default client;

export const getLang = (localeCode, page) => {
  return new Promise(resolve => {
    client.getEntries({
      'limit': 500,
      'locale': localeCode,
      'fields.page': page,
      'content_type': 'article',
      'select': 'fields.block,fields.text',
    }).then(res => {
      resolve(res.items.reduce((obj, {fields}) => {
        return chainJSON(fields.block, fields.text, obj);
      }, {}));
    });
  });
}

export const getImage = page => {
  return new Promise(resolve => {
    client.getEntries({
      'limit': 500,
      'fields.page': page,
      'content_type': 'images',
      'select': 'fields.block,fields.image',
    }).then(res => {
      resolve(res.items.reduce((obj, {fields}) => {
        return chainJSON(fields.block, fields.image, obj);
      }, {}));
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/Contentful.js